import paymentReducer from './paymentReducer';

export default paymentReducer;
